<template>
  <div class="evaluate-con">
    <div
      class="goodsStyle acea-row row-between"
      v-for="item in orderItems"
      :key="item.id"
    >
      <div class="pictrue">
        <img
          :src="item.itemPic + '!tmb_130'"
          class="image"
          v-if="item.itemPic"
        />
        <img src="@assets/images/def_service.jpg" class="image" v-else />
      </div>
      <div class="text acea-row row-between">
        <div class="name line2">
          {{ item.itemName }}
          <div style="color: #999; margin-top: 5px" v-if="item.waiterName">
            服务顾问：{{ item.waiterName }}
          </div>
        </div>
        <div class="money">
          <div>￥{{ item.price }}</div>
          <div class="num">x{{ item.num }}</div>
        </div>
      </div>
    </div>
    <div class="score">
      <div class="item acea-row row-middle">
        <div>环境卫生</div>
        <div class="starsList">
          <rate v-model="form.healthScore" :count="5" />
        </div>
        <span class="evaluate">{{ scoreText(form.healthScore) }}</span>
      </div>
      <div class="textarea">
        <textarea
          placeholder="服务满足你的期待么？说说你的想法，分享给想买的他们吧~"
          v-model="form.comment"
        ></textarea>
        <div class="list acea-row row-middle">
          <div
            class="pictrue"
            v-for="(item, index) in uploadPictures"
            :key="index"
          >
            <img :src="item" />
            <span
              class="iconfont icon-guanbi1 font-color-red"
              @click="uploadPictures.splice(index, 1)"
            ></span>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="imageuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="uploadPictures.length < 8"
          >
            <div
              class="pictrue uploadBnt acea-row row-center-wrapper row-column"
            >
              <span class="iconfont icon-icon25201"></span>
              <div>上传图片</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div>
      <div
        class="waiter-card"
        v-for="(waiter, waiterId) in waiters"
        :key="waiterId"
      >
        <div class="waiter-name line1">
          {{ waiter.waiterName || "服务老师" }}
        </div>
        <div class="waiter-items line1">
          服务项目：{{ waiter.itemNames.join("、") }}
        </div>
        <div class="item acea-row row-middle">
          <div>手艺</div>
          <div class="starsList">
            <rate v-model="form.waiterScores[waiterId].skillScore" :count="5" />
          </div>
          <span class="evaluate">{{
            scoreText(form.waiterScores[waiterId].skillScore)
          }}</span>
        </div>
        <div class="item acea-row row-middle">
          <div>服务态度</div>
          <div class="starsList">
            <rate
              v-model="form.waiterScores[waiterId].attitudeScore"
              :count="5"
            />
          </div>
          <span class="evaluate">{{
            scoreText(form.waiterScores[waiterId].attitudeScore)
          }}</span>
        </div>
        <div
          class="waiter-comment-toggle acea-row row-middle"
          v-if="!commentOpen[waiterId]"
          @click="toggleWaiterComment(waiterId)"
        >
          <span class="iconfont icon-bianji"></span>
          <span>想对老师说（选填）</span>
        </div>
        <div class="textarea" v-else>
          <textarea
            v-model="form.waiterScores[waiterId].comment"
            placeholder="想对老师说点什么（选填）"
          ></textarea>
          <div
            class="waiter-comment-toggle collapse"
            @click="toggleWaiterComment(waiterId)"
          >
            收起
          </div>
        </div>
      </div>
      <div class="evaluateBnt bg-color-red" @click="submit">立即评价</div>
    </div>
  </div>
</template>
<script>
import { orderDetail, postReviewSave } from "@api/order";
import { trim } from "@utils";
import { required } from "@utils/validate";
import VueCoreImageUpload from "vue-core-image-upload";
import { validatorDefaultCatch } from "@utils/dialog";
import { Rate, Toast } from "vant";

const NAME = "OrderComment";

export default {
  name: NAME,
  components: {
    Rate,
    VueCoreImageUpload,
  },
  props: {},
  data: function () {
    return {
      orderCon: {},
      url: `/api/upload/oss`,
      headers: {
        "authori-zation": "Bearer " + this.$store.state.app.token,
      },
      uploadPictures: [],
      commentOpen: {},
      form: {
        orderId: this.$route.params.id,
        healthScore: 0,
        comment: "",
        pictures: "",
        waiterScores: {},
      },
    };
  },
  computed: {
    orderItems() {
      return this.orderCon.items || [];
    },
    waiters() {
      return this.orderItems
        .filter((item) => item.waiterId)
        .reduce((map, item) => {
          if (!map[item.waiterId]) {
            map[item.waiterId] = { waiterName: "", itemNames: [] };
          }
          if (item.waiterName) {
            map[item.waiterId].waiterName = item.waiterName;
          }
          if (item.itemName) {
            map[item.waiterId].itemNames.push(item.itemName);
          }
          return map;
        }, {});
    },
  },
  mounted: function () {
    this.getOrderProduct();
  },
  watch: {
    "orderCon.items": function () {
      this.initWaiterScores();
    },
    $route(n) {
      if (n.name === NAME && this.form.orderId !== n.params.id) {
        this.resetForm(n.params.id);
        this.getOrderProduct();
      }
    },
  },
  methods: {
    getOrderProduct: function () {
      orderDetail(this.form.orderId)
        .then((res) => {
          const result = res.result || {};
          if (result.isComment === 1) {
            this.$dialog.error("该订单已评价");
            this.$router.replace({
              path: "/order/detail/" + this.form.orderId,
            });
            return;
          }
          this.orderCon = result;
        })
        .catch((err) => {
          this.$dialog.error((err && err.msg) || "获取订单信息失败");
        });
    },
    initWaiterScores: function () {
      const scores = {};
      const open = {};
      this.orderItems
        .filter((item) => item.waiterId)
        .forEach((item) => {
          if (!scores[item.waiterId]) {
            scores[item.waiterId] = {
              waiterId: item.waiterId,
              waiterName: item.waiterName || "",
              skillScore: 0,
              attitudeScore: 0,
              comment: "",
            };
            open[item.waiterId] = false;
          } else if (item.waiterName && !scores[item.waiterId].waiterName) {
            scores[item.waiterId].waiterName = item.waiterName;
          }
        });
      this.form.waiterScores = scores;
      this.commentOpen = open;
    },
    resetForm: function (orderId) {
      this.orderCon = {};
      this.uploadPictures = [];
      this.commentOpen = {};
      this.form = {
        orderId: orderId,
        healthScore: 0,
        comment: "",
        pictures: "",
        waiterScores: {},
      };
    },
    toggleWaiterComment: function (waiterId) {
      this.$set(this.commentOpen, waiterId, !this.commentOpen[waiterId]);
    },
    scoreText: function (score) {
      return score ? score + "分" : "";
    },
    imageuploaded(res) {
      if (res.code !== 200) {
        return this.$dialog.error(res.msg || "上传图片失败");
      }
      this.uploadPictures.push(res.result.path);
    },
    async submit() {
      const form = this.form;
      const values = {
        healthScore: form.healthScore || "",
      };
      const rules = {
        healthScore: [
          required("请选择环境卫生分数", {
            type: "number",
            min: 1,
            max: 5,
          }),
        ],
      };
      Object.keys(form.waiterScores).forEach((key) => {
        const waiter = form.waiterScores[key];
        const prefix = (waiter.waiterName || "老师") + "的";
        const skillField = "skill_" + key;
        const attitudeField = "attitude_" + key;
        rules[skillField] = [
          required("请选择" + prefix + "手艺分数", {
            type: "number",
            min: 1,
            max: 5,
          }),
        ];
        values[skillField] = waiter.skillScore || "";
        rules[attitudeField] = [
          required("请选择" + prefix + "服务态度分数", {
            type: "number",
            min: 1,
            max: 5,
          }),
        ];
        values[attitudeField] = waiter.attitudeScore || "";
      });
      try {
        await this.$validator(rules).validate(values);
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      Toast.loading({ message: "提交中", forbidClick: true });
      postReviewSave({
        orderId: form.orderId,
        healthScore: form.healthScore,
        comment: trim(form.comment),
        pictures: this.uploadPictures.join(","),
        waiters: Object.values(form.waiterScores),
      })
        .then(() => {
          Toast.clear();
          this.$dialog.success("评价成功");
          this.$router.replace({
            path: "/order/detail/" + form.orderId,
          });
        })
        .catch((res) => {
          Toast.clear();
          this.$dialog.error(res.msg);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.evaluate-con {
  .pictrue {
    .image {
      border: 1px solid #c3cbd6;
    }
  }

  .score .item > div:first-child {
    width: 1.6rem;
  }

  .score .textarea .list .pictrue.uploadBnt {
    border: 1px solid #ddd;
  }

  .waiter-card {
    margin-top: 0.45rem;
    padding: 0.3rem;
    background-color: #fafafa;
    border-radius: 0.1rem;

    .waiter-name {
      color: #282828;
      font-size: 0.3rem;
      font-weight: 600;
    }

    .waiter-items {
      margin-top: 0.08rem;
      color: #999;
      font-size: 0.24rem;
    }

    .item {
      margin-top: 0.25rem;
    }

    .waiter-comment-toggle {
      margin-top: 0.25rem;
      color: #999;
      font-size: 0.24rem;

      .iconfont {
        margin-right: 0.08rem;
        font-size: 0.26rem;
      }

      &.collapse {
        padding: 0.15rem 0.3rem 0.25rem 0;
        text-align: right;
      }
    }

    .textarea {
      width: auto;
      margin-top: 0.25rem;
      background-color: #fff;

      textarea {
        height: 0.9rem;
      }
    }
  }
}
</style>
